document.addEventListener('DOMContentLoaded', () => {
  InfiniteScroll({
    default_pagination_selector: '.pagination-wrapper', // Required
    product_grid_selector: '#product-grid', // Required
    card_selector: '#product-grid li.grid__item', // Required
  });
});

const InfiniteScroll = (options) => {
  const { default_pagination_selector, product_grid_selector, card_selector } = options;

  let isRunning = false;
  let hasMorePages = true;

  /* THIS WILL ONLY HIDE THE DEFAULT PAGINATION IF THIS SCRIPT LOADS FOR FALLBACK AND SEO PURPOSE */
  const style = document.createElement('style');
  style.innerHTML = `
        ${default_pagination_selector}{
            display: none;
        }
    `;
  document.head.appendChild(style);

  function createSpinner() {
    const spinnerWrapper = document.createElement('div');
    const spinner = document.createElement('div');
    spinner.id = 'infinite-scroll-spinner';
    spinner.className = 'infinite-scroll__spinner';
    spinnerWrapper.className = 'infinite-scroll__spinner-wrapper';
    spinnerWrapper.appendChild(spinner);
    const productList = document.querySelector(product_grid_selector);

    return {
      add: () => productList.insertAdjacentElement('afterend', spinnerWrapper),
      kill: () => spinnerWrapper.remove(),
    };
  }
  function generateNextPageURL(currentPage) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if (currentPage) {
      const nextPage = parseInt(currentPage) + 1;
      params.set('page', nextPage);
    } else {
      params.append('page', 2);
    }
    url.search = params.toString();
    return url.toString();
  }
  async function loadNextPage(currentPage) {
    if (isRunning) return;
    isRunning = true;
    const spinner = createSpinner();
    spinner.add();
    try {
      const nextPageURL = generateNextPageURL(currentPage);
      const res = await fetch(nextPageURL);
      const html = await res.text();
      const parser = new DOMParser();

      const newDoc = parser.parseFromString(html, 'text/html');
      const newGrid = newDoc ? newDoc.querySelector(product_grid_selector) : null;
      const newCards = newGrid ? newGrid.querySelectorAll(card_selector) : null;
      const productList = document.querySelector(product_grid_selector);
      const loadedLastPage = newDoc.querySelector('[data-infinite-scroll-last-page]');
      // Append all new cars to the existing grid
      if (newCards.length > 0) {
        newCards.forEach((card) => {
          productList.appendChild(card);
        });
      }
      return { newCardsLoaded: newCards.length, loadedLastPage };
    } catch (err) {
      console.error(err);
    } finally {
      spinner.kill();
      isRunning = false;
    }
  }

  async function monitorScrollDistance() {
    const productGrid = document.querySelector(product_grid_selector);
    const triggerTarget = productGrid.lastElementChild;
    const rect = triggerTarget.getBoundingClientRect();
    const distanceFromBottom = rect.bottom - window.innerHeight;
    const isLastPage = document.querySelector('[data-infinite-scroll-last-page]');
    const dataElement = document.querySelector('[data-infinite-scroll-current-page]');
    const currentPage = dataElement ? dataElement.getAttribute('data-infinite-scroll-current-page') : null;
    if (!currentPage || isLastPage) {
      hasMorePages = false;
    } else {
      hasMorePages = true;
    }
    if (distanceFromBottom >= 800 || !hasMorePages || isRunning) return;
    const { newCardsLoaded, loadedLastPage } = await loadNextPage(currentPage);
    if (newCardsLoaded > 0) {
      dataElement.setAttribute('data-infinite-scroll-current-page', parseInt(currentPage) + 1);
    }
    if (loadedLastPage) {
      dataElement.setAttribute('data-infinite-scroll-last-page', 'true');
    }
  }
  window.addEventListener('scroll', monitorScrollDistance);
};
